import DefaultLayout from '##/Default';
import List from './List';


const routes = [
    {
        path: '/properties/:property_id/reports/renewals',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'Renewal Report'
    }
];

export default routes;
